import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MainHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-[#141414] px-4 md:px-6 !mb-2">
      <div className="flex items-center justify-between">
        {/* Logo and Title */}
        <div className="flex items-center gap-2 md:gap-3 !pl-2 md:!pl-4">
          {/* TLP Helmet Logo */}
          <img 
            src="/TLP Helmet.png" 
            alt="The Launch Pad Logo" 
            className="w-12 h-12 md:w-12 md:h-12 object-contain"
          />
          
          {/* Stacked Text */}
          <div className="text-white">
            <div className="text-sm font-bold tracking-wider font-avenir">THE</div>
            <div className="text-sm font-bold tracking-wider font-avenir">LAUNCH</div>
            <div className="text-sm font-bold tracking-wider font-avenir">PAD</div>
          </div>
        </div>

        {/* Desktop Navigation Links */}
        {isLargeScreen && (
          <div className="flex items-center gap-4 xl:gap-6">
          <Link
            to="/chat"
            className="text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir text-center p-3 lg:p-4"
          >
            <div className="text-sm font-bold tracking-wider font-avenir">CHAT</div>
          </Link>
          
          <Link
            to="/overlay"
            className="text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir text-center p-3 lg:p-4"
          >
            <div className="text-sm font-bold tracking-wider font-avenir">OVERLAY</div>
          </Link>
          
          <button
            onClick={handleLogout}
            className="text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir text-center p-3 lg:p-4"
          >
            <div className="text-sm font-bold tracking-wider font-avenir">LOG</div>
            <div className="text-sm font-bold tracking-wider font-avenir">OUT</div>
          </button>
          </div>
        )}

        {/* Mobile Menu Button */}
        {!isLargeScreen && (
          <button
            onClick={toggleMobileMenu}
            className="text-white hover:text-red-400 transition-colors p-2"
            aria-label="Toggle mobile menu"
          >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
          </button>
        )}
      </div>

      {/* Mobile Navigation Menu */}
      {!isLargeScreen && isMobileMenuOpen && (
        <div className="bg-[#1a1a1a] border-t border-gray-700">
          <div className="px-4 py-3 space-y-2">
            <Link
              to="/chat"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir py-3 px-4 rounded hover:bg-gray-800"
            >
              <div className="text-sm font-bold tracking-wider font-avenir">CHAT</div>
            </Link>
            
            <Link
              to="/overlay"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir py-3 px-4 rounded hover:bg-gray-800"
            >
              <div className="text-sm font-bold tracking-wider font-avenir">OVERLAY</div>
            </Link>
            
            <button
              onClick={() => {
                handleLogout();
                setIsMobileMenuOpen(false);
              }}
              className="block w-full text-left text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir py-3 px-4 rounded hover:bg-gray-800"
            >
              <div className="text-sm font-bold tracking-wider font-avenir">LOG OUT</div>
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default MainHeader;
